import {Component, Inject, Input, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {ResponseForm} from '../../../common/components/form/models/responsedemat.model';
import {ResponsesService} from '../../../common/services/responses/responses.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Individu, PubSubService} from '@Common/core/services';
import {SubSink} from '@Common/core/utils/subsink';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {HelperService} from '../../../common/services/helper.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {FormModel, FormType} from '../../../common/components/form/models';
import {DatePipe} from '@angular/common';
import {finalize} from 'rxjs/operators';
import {InstructionService} from '../../../common/services/instructions/instruction.service';

@Component({
  selector: 'app-search-demandes-results',
  templateUrl: './search-demandes-results.component.html',
  styleUrls: ['./search-demandes-results.component.scss']
})
export class SearchDemandesResultsComponent implements OnInit{
  @Input() set connecte(_connect: Individu) {
    if (_connect) {
      this.extraParams.set('by_gestionnaire', _connect.uid);
    } else {
      this.extraParams.delete('by_gestionnaire');
    }
  }
  dsResponses: MatDataSourceGeneric<ResponseForm> = new MatDataSourceGeneric<ResponseForm>();
  extraParams: Map<string, string> = new Map<string, string>();
  loaderProgress = false;
  columns: ColumnDataTable[] = [
    {
      columnDef: 'reference', header: 'Reference',
      display: (row: ResponseForm) => row?.reference,
      sort: false, flex: 9
    },
    {
      columnDef: 'form_obj.nom', header: 'Formulaire',
      display: (row: ResponseForm) => row?.form_obj?.nom,
      sort: false, flex: 15
    },
    {
      columnDef: 'user_obj.last_name', header: 'Demandeur',
      display: (row: ResponseForm) => `${row?.user_obj.last_name} ${row?.user_obj.first_name}`,
      sort: false
    },
    {
      columnDef: 'instruction', header: 'Instruction',
      display: (row: ResponseForm) => this._displayInstruction(row),
      sortField: 'last_instruction__state',
      sort: true, flex: 8
    },
    {
      columnDef: 'dt_updated', header: 'Modifié le', display: (element: FormModel) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${element.dt_updated}`, 'dd/MM/yyyy H:mm')}</strong>`;
      },
      sort: false
    },
  ];
  actions: ActionDataTable[] = [{
    label: 'modal', tooltip: 'Voir la demande en modale', icon: 'outbound',
    tooltipfct: (row: ResponseForm) => {
      if (row.form_obj?.type === FormType.Sondage) {
        return 'Voir la réponse en modale';
      }
      return 'Voir la demande en modale';
    },
    click: (row: ResponseForm) => this.modaleResponse(row),
    iconcolor: 'accent',
  }];
  results: ResponseForm[] = [];
  search = '';
  displayedColumns = ['reference', 'formulaire', 'demandeur'];
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  loading = false;
  subSink = new SubSink();
  constructor(@Inject(LOCALE_ID) private locale: string,
              protected router: Router,
              private responseSvc: ResponsesService,
              private instructionSvc: InstructionService) { }

  ngOnInit(): void {
    this.dsResponses.daoService = this.responseSvc;
    this.instructionSvc.onObjectChanged$.subscribe(_object => this.dataTable?.reload());
  }
  private _displayInstruction(response: ResponseForm) {
    return this.responseSvc.stateInstructionDisplayColor(response);
  }
  modaleResponse(response: ResponseForm) {
    this.loading = true;
    this.subSink.sink = this.responseSvc
      .get(response.uuid)
      .pipe(finalize(() => this.loading = false))
      .subscribe(_response => this.responseSvc.openInModaleResponse(_response));
  }
}
